<template>
  <v-card height="100%">
    <v-card-title primary-title>
      <div class="headline">{{labels.vehicle}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.vehRegNo}}</v-subheader>
            <div v-if="motorForm.vehRegNo">{{motorForm.vehRegNo}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6 v-if="$mode !== 'ecics'">
            <v-subheader class="queryLabel">{{labels.vehUsg}}</v-subheader>
            <div>{{motorForm.vehUsg}} - {{query.vehUsg}}</div>
          </v-flex>
          <v-flex xs6 v-else></v-flex>
          <v-flex xs6>
            <v-layout row wrap align-content-start>
              <v-flex xs12>
                <v-subheader class="queryLabel">{{labels.vehMake}}</v-subheader>
                <div>{{motorForm.vehMake}} - {{query.vehMake}}</div>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="queryLabel">{{labels.vehModel}}</v-subheader>
                <div>{{motorForm.vehModel}} - {{query.vehModel}}</div>
              </v-flex>
              <v-flex xs12 v-if="$mode !== 'ecics'">
                <v-subheader class="queryLabel">{{labels.vehValue}}</v-subheader>
                <div v-if="motorForm.vehValue !== null">{{$store.state.agency.quotation.commonInfo.currPrefix}}{{formatDisplayNumber(motorForm.vehValue)}}</div>
                <div v-else> - </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs6>
            <v-card color="grey lighten-4">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex lg8 xs6 class="modelInfo">
                    <v-icon>mdi-car-sports</v-icon>
                    <span>{{labels.vehBodyType}}</span>
                  </v-flex>
                  <v-flex lg4 xs6>
                    {{query.vehBodyType}}
                  </v-flex>
                  <v-flex lg8 xs6 class="modelInfo">
                    <v-icon>mdi-engine-outline</v-icon>
                    <span>{{labels.vehCapacity}}</span>
                  </v-flex>
                  <v-flex lg4 xs6>
                    {{query.vehCapacity}}
                  </v-flex>
                  <template v-if="$mode !== 'ecics'">
                    <v-flex lg8 xs6 class="modelInfo">
                      <v-icon>mdi-weight</v-icon>
                      <span>{{labels.vehTonnage}}</span>
                    </v-flex>
                    <v-flex lg4 xs6>
                      {{query.vehTonnage}}
                    </v-flex>
                  </template>
                  <v-flex lg8 xs6 class="modelInfo">
                    <v-icon>mdi-seat-recline-normal</v-icon>
                    <span>{{labels.vehNoSeats}}</span>
                  </v-flex>
                  <v-flex lg4 xs6>
                    {{query.vehNoSeats}}
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.vehRegMth}}</v-subheader>
            <div v-if="motorForm.vehRegMth !== null">{{motorForm.vehRegMth}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.vehRegYr}}</v-subheader>
            <div v-if="motorForm.vehRegYr !== null">{{motorForm.vehRegYr}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{labels.vehManuYr}}</v-subheader>
            <div v-if="motorForm.vehManuYr !== null">{{motorForm.vehManuYr}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.engineNo}}</v-subheader>
            <div v-if="motorForm.engineNo !== null">{{motorForm.engineNo}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.chassisNo}}</v-subheader>
            <div v-if="motorForm.chassisNo !== null">{{motorForm.chassisNo}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.finInst}}</v-subheader>
            <div v-if="query.finInst !== null">{{query.finInst}}</div>
            <div v-else> - </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <template v-if="$mode === 'ecics'">
      <v-divider></v-divider>
      <v-card-title>
        <div class="body-2">{{labels.tonnInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.maxLaden}}</v-subheader>
              <div v-if="motorForm.maxLaden !== null">{{motorForm.maxLaden}} KG</div>
              <div v-else> - </div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.unLaden}}</v-subheader>
              <div v-if="motorForm.unLaden !== null">{{motorForm.unLaden}} KG</div>
              <div v-else> - </div>
            </v-flex>
            <v-flex xs12>
              <v-subheader class="queryLabel">{{labels.calcTonnage}}</v-subheader>
              <div v-if="motorForm.calcTonnage !== null">{{motorForm.calcTonnage}}</div>
              <div v-else> - </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import { formatDisplayNumber } from '@/utils/number'

export default {
  data() {
    return {
      labels: {
        vehicle: 'Vehicle',
        vehRegNo: 'Registration No.',
        vehMake: 'Make',
        vehModel: 'Model',
        vehBodyType: 'Body Type',
        vehCapacity: 'Capacity',
        vehTonnage: 'Tonnage',
        vehNoSeats: 'No. of Seats',
        vehManuYr: 'Manufacture Year',
        vehRegYr: 'Registration Year',
        vehRegMth: 'Registration Month',
        vehUsg: 'Usage',
        vehValue: 'Value',
        engineNo: 'Engine No.',
        chassisNo: 'Chassis No.',
        finInst: 'Financial Company',
        maxLaden: 'Maximum Laden Weight',
        unLaden: 'Maximum Unladen Weight',
        calcTonnage: 'Calculated Tonnage',
        tonnInfo: 'Tonnage Information'
      }
    }
  },
  computed: {
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    motorForm() {
      return this.$store.state.agency.quotation.motorForm
    },
    query() {
      return this.$store.state.agency.quotation.queryInfo
    }
  },
  methods: {
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  }
}
</script>

<style lang="scss">
.modelInfo {
  span {
    padding-left: 10px;
  }
}
</style>
